import {Skeleton, Stack} from '@mui/material';
import React from 'react';

export function UserInfoSkeleton() {
	return (
		<Stack>
			<Skeleton height="0.875rem" width="25%" />
			<Skeleton height="1rem" />
		</Stack>
	);
}
